import React, { useEffect, useState } from "react";
import AddPartyPopup from "../Component/AddPartyPopup";
import { API_BASE_URL } from "../config";

export default function Partys() {
  const [party, setParty] = useState([]);
  const [newParty, setNewParty] = useState({ courtName: "", location: "" });
  const [editingParty, setEditingParty] = useState(null);

  // Fetch all courts
  useEffect(() => {
    fetchParty();
  }, []);

  const fetchParty = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/PartyMaster/GetParty`, {
          headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setParty(data);
      } else {
        console.error("Failed to fetch party");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Add new Party
  const handleAddParty = async (newParty) => {
    // e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/PartyMaster/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(newParty),
      });
      if (res.ok) {
        fetchParty(); // Refresh list
        setNewParty({ courtName: "", location: "" });
        alert("Party added successfully!");
      } else {
        console.error("Failed to add status");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Delete court
  const handleDeleteParty = async (id) => {
    if (!window.confirm("Are you sure you want to delete this status?")) return;

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/Court/deletecourt/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        setParty((prev) => prev.filter((c) => c.id !== id));
        alert("Court deleted successfully!");
      } else {
        console.error("Failed to delete court");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Update court
  const handleUpdateParty = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/PartyMaster/update/${editingParty.partyId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(editingParty),
      });
      if (res.ok) {
        fetchParty();
        setEditingParty(null);
        alert("Party updated successfully!");
      } else {
        console.error("Failed to update party");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Manage Party</h2>      
      <AddPartyPopup onAddParty={handleAddParty} />
      {/* Party Table */}
      <table border="1" cellPadding="10" style={{ width: "100%", marginTop: "20px" }}>
        <thead style={{ background: "#f4f4f4" }}>
          <tr>
            <th>Party Name</th>
            <th>Father_Name</th>
            <th>Mother_Name</th>
            <th>Address</th>
            <th>ContactNo</th>
            <th>Email_Id</th>
            <th>WhatsappNo</th>
            <th>Party_Type</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {party.length > 0 ? (
            party.map((party) => (
              <tr key={party.partyId}>
                <td>
                  {editingParty?.partyId === party.partyId ? (
                    <input
                      type="text"
                      value={editingParty.partyName}
                      onChange={(e) =>
                        setEditingParty({ ...editingParty, partyName: e.target.value })
                      }
                    />
                  ) : (
                    party.partyName
                  )}
                </td>
                <td>
                  {editingParty?.partyId === party.partyId ? (
                    <input
                      type="text"
                      value={editingParty.father_Name}
                      onChange={(e) =>
                        setEditingParty({ ...editingParty, father_Name: e.target.value })
                      }
                    />
                  ) : (
                    party.father_Name
                  )}
                </td>
                <td>
                  {editingParty?.partyId === party.partyId ? (
                    <input
                      type="text"
                      value={editingParty.mother_Name}
                      onChange={(e) =>
                        setEditingParty({ ...editingParty, mother_Name: e.target.value })
                      }
                    />
                  ) : (
                    party.mother_Name
                  )}
                </td>
                <td>
                  {editingParty?.partyId === party.partyId ? (
                    <input
                      type="text"
                      value={editingParty.address}
                      onChange={(e) =>
                        setEditingParty({ ...editingParty, address: e.target.value })
                      }
                    />
                  ) : (
                    party.address
                  )}
                </td>
                <td>
                  {editingParty?.partyId === party.partyId ? (
                    <input
                      type="text"
                      value={editingParty.contactNo}
                      onChange={(e) =>
                        setEditingParty({ ...editingParty, contactNo: e.target.value })
                      }
                    />
                  ) : (
                    party.contactNo
                  )}
                </td>
                <td>
                  {editingParty?.partyId === party.partyId ? (
                    <input
                      type="text"
                      value={editingParty.email_Id}
                      onChange={(e) =>
                        setEditingParty({ ...editingParty, email_Id: e.target.value })
                      }
                    />
                  ) : (
                    party.email_Id
                  )}
                </td>
                <td>
                  {editingParty?.partyId === party.partyId ? (
                    <input
                      type="text"
                      value={editingParty.whatsappNo}
                      onChange={(e) =>
                        setEditingParty({ ...editingParty, whatsappNo: e.target.value })
                      }
                    />
                  ) : (
                    party.whatsappNo
                  )}
                </td>
                <td>
                  {editingParty?.partyId === party.partyId ? (
                    <input
                      type="text"
                      value={editingParty.party_Type}
                      onChange={(e) =>
                        setEditingParty({ ...editingParty, party_Type: e.target.value })
                      }
                    />
                  ) : (
                    party.party_Type
                  )}
                </td>
                <td>
                  {editingParty?.partyId === party.partyId ? (
                    <>
                      <button onClick={handleUpdateParty}>Save</button>
                      <button onClick={() => setEditingParty(null)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => setEditingParty(party)}>Edit</button>
                      <button onClick={() => handleDeleteParty(party.partyId)}>Delete</button>
                    </>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3">No Party found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
